<template>
  <div class="grid-x grid-margin-x">
    <div v-if="isMobile" class="cell title-mobile padding-bottom-xs">
      <ProductTitle />
    </div>
    <div :class="cellLeft">
      <Media />
    </div>
    <div :class="cellRight">
      <div v-if="!isMobile" class="title margin-bottom-s">
        <ProductTitle />
      </div>
      <ColorSwatches v-if="showColorSwatches" :id="productId" class="margin-bottom-xs" :color-props="colorProps" />
      <div v-if="isConsolidatedMasterBcom">
        <ProductPrice :id="productId" :product="product" />
      </div>
      <GiftCardForm />
      <LazyLoadWhenInViewport>
        <SponsoredItemTop
          v-if="showSponsoredItemTop"
          :enable-click-tags-for-s-m-products="killswitches.enableClickTagsForSMProducts"
          :is-simplification-mcom-on="killswitches.priceSimplificationEnabled"
        />
      </LazyLoadWhenInViewport>
    </div>
    <template v-if="isBcom">
      <ProsZoneAVertical v-if="!isMobile" data-testid="pros-section" class="cell large-12 margin-top-xl" />
    </template>
    <div class="cell large-12" data-testid="product-details-section">
      <ProductDetails :class="{ 'margin-top-xl': !isMobile && !showSponsoredItemTop }" data-testid="product-details-facade" />
    </div>
    <template v-if="isMcom">
      <ProsZoneAVertical v-if="!isMobile" data-testid="pros-section" class="cell large-12 small-margin-top-m large-margin-top-xl" />
    </template>
  </div>
</template>

<script setup>
import { useInitColorPDP as useInitColor } from '@nuxt-common/media-card-large/app/modules/color';
import { useInitSizePDP } from '@nuxt-common/media-card-large/app/modules/size';
import SponsoredItemTop from '@nuxt-common/site-monetization/app/components/SponsoredItemTop';
import ProductTitle from '~/components/productTitle/ProductTitle.common.vue';
import Media from '~/components/common/Media/Media.vue';
import StaticImportProductDetails from '~/modules/productDetails/components/ProductDetails';
import LazyHydratedProductDetails from '~/modules/lazy-hydration/components/ProductDetails';
import ProsZoneAVertical from '~/modules/pros/ProsZoneAVertical';
import ColorSwatches from '~/modules/color/ColorSwatches.vue';
import GiftCardForm from '~/modules/giftcards/components/GiftCardForm.vue';
import useColor from '~/modules/color/composables/useColor';
import { useBrand } from '~/composables/useBrand';
import { useProduct } from '~/modules/product/composables/useProduct';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useProductType } from '~/composables/useProductType';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import LazyLoadWhenInViewport from '~/components/common/LazyLoadWhenInViewport.vue';
import { usePageData } from '~/composables/usePageData';
import useGridLayoutConfig from '~/composables/useGridLayoutConfig';

import ProductPrice from '~/modules/price/components';

const { isBcom, isMcom } = useBrand();
const { isMobile } = useDeviceType();
const { killswitches } = useKillswitches();
let ProductDetails = StaticImportProductDetails;

// TODO: remove later once lazy hydration testing is over
if (killswitches.isLazyHydrationEnabled) {
  ProductDetails = LazyHydratedProductDetails;
}

const { productId, productData: product } = useProduct();
const { hasColorSwatchesFlag, hasColorsFlag } = useProductFlags();
const { traits } = usePageData();
useInitColor({ id: productId, data: traits?.color[productId] });
useInitSizePDP({ id: productId, data: traits?.size?.[productId] });

const { isConsolidatedMaster, isLatchKey } = useProductType();
const { colorProps } = useColor();
const showColorSwatches = isBcom ? hasColorsFlag || isLatchKey : hasColorSwatchesFlag;
const isConsolidatedMasterBcom = isBcom && isConsolidatedMaster;
const { showSponsoredItemTop } = useFeatureEligibility();
const { cellLeft, cellRight } = useGridLayoutConfig();
</script>

<style lang="scss" brand="mcom" scoped>
@import '~settingSCSS';
@include title;
</style>

<style lang="scss" brand="bcom" scoped>
@import '~settingSCSS';
@include title;
</style>
